import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_permissions',
};

export const getPermissionsRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
